
import user from '../user'
import customer from '../customer'
import project from '../project'

export default {
  namespaced: true,
  modules: {
    user,
    customer,
    project
  }
}
